// components/BarChartWidget.jsx
import { BarChart } from '@mui/x-charts/BarChart';
import { Box, Typography, IconButton } from '@mui/material';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { useApiTrigger } from '../../hooks/useApiTrigger';
import { safeParseJSON } from '../../../../utils/jsonValidator';

const parseDataForMuiBarChart = (rawData) => {
    const categories = rawData.map(item => item.category);
    const seriesKeys = Object.keys(safeParseJSON(rawData[0]))
        .filter(key => key !== 'category');
    const dataValues = seriesKeys.map(key => ({
        label: key,
        data: rawData.map(item => item[key] || 0),
    }));

    return {
        categories,
        dataValues
    };
};

const BarGroupChart = ({ data, filters }) => {
    const { dto: dtoChart } = useApiTrigger(data, filters);
    const dto = parseDataForMuiBarChart(dtoChart);

    return (
        <Box
            sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', p: 1 }}
        >
            <Box display="flex" justifyContent="space-between" alignItems="center"
                sx={{ height: 36, flexShrink: 0 }}
            >
                <Typography
                    fontWeight={500} noWrap
                >
                    {data.accion}
                </Typography>
                {/* <IconButton size="small">
                    <InfoOutlined sx={{ fontSize: 16 }} />
                </IconButton> */}
            </Box>

            <BarChart
                xAxis={[{
                    data: dto.categories,
                    scaleType: 'band',
                    tickLabelStyle: {
                        fontSize: 12,
                    },
                }]}
                yAxis={[{
                    width: 45,
                    tickLabelStyle: {
                        fontSize: 12,
                    },
                }]}
                series={dto.dataValues}
                grid={{ vertical: false, horizontal: true }}
                margin={{ left: 0, right: 1, top: 1, bottom: 1 }}
                slotProps={{
                    legend: {
                        hidden: true,
                        itemMarkWidth: 10,
                        itemMarkHeight: 10,
                        labelStyle: {
                            fontSize: 12,
                        },
                    },
                }}
                sx={{
                    '& .MuiChartsGrid-line': {
                        strokeDasharray: '5 5', // Líneas punteadas
                        stroke: '#E0E0E0',      // Color gris claro
                    },
                }}
            />
        </Box>
    );
}

export default BarGroupChart;